import { TreeNodeAncestorReadDto } from '../_generated/api/structure'
import { buildStructureLink } from '../tools/link'
import { StructureType, StructureTypes } from './Structure'
import ApiLifeCycleModel, { CommonLifeCycleData } from './ApiLifeCycleModel'

export interface CommonStructureData extends CommonLifeCycleData {
    id?: string | null
    name?: string | null
    organizationId?: string | null
    rootId?: string | null
    parentId?: string | null
    ancestors?: TreeNodeAncestorReadDto[] | null
}

export interface Ancestor {
    id: string
    name: string
    link: string
}

export default class ApiStructureModel<T extends CommonStructureData> extends ApiLifeCycleModel<T> {
    get id(): string {
        return this.data.id ?? ''
    }

    get name(): string {
        return this.data.name ?? ''
    }

    get organizationId(): string {
        return this.data.organizationId ?? ''
    }

    get rootId(): string {
        return this.data.rootId ?? ''
    }

    get parentId(): string | undefined {
        return this.data.parentId ?? undefined
    }

    get isRoot(): boolean {
        return this.parentId == null
    }

    get referenceType(): StructureType {
        return StructureTypes.None
    }

    get referenceLink(): string {
        return buildStructureLink(this.referenceType, this.id)
    }

    get parentLink(): string {
        // NOTE: Logically, all parents must be Project types.
        return buildStructureLink(StructureTypes.Project, this.parentId ?? '')
    }

    get ancestors(): Ancestor[] {
        return (this.data.ancestors ?? []).map(({ id, name }) => ({
            id,
            name,
            link: buildStructureLink(
                this.id === id ? this.referenceType : StructureTypes.Project,
                id
            ),
        }))
    }
}
